exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../../assets/img/success_smile.svg"));

// Module
exports.push([module.id, ".module-cards-order-result .success-img {\n  background: url(" + ___CSS_LOADER_URL___0___ + ") no-repeat center;\n  background-size: cover;\n  width: 80px;\n  height: 80px;\n  margin: 0 auto 24px auto;\n  content: none;\n}\n.module-cards-order-result .success-heading {\n  margin-bottom: 24px;\n  color: #64B22C;\n  text-align: center;\n}\n", ""]);

